import { TabI } from 'src/app/shared/models/navigation-tabI';

export const LANDING_PAGE_TABS_LIST: TabI[] = [
    {
        label: 'All Products',
        route: 'all-products'
    },
    // {
    //     label: 'Architecture Service',
    //     route: 'architecture-service'
    // },    {
    //     label: 'Platforms',
    //     route: 'platforms'
    // },    {
    //     label: 'Cloud Engineering',
    //     route: 'cloud-engineering'
    // },    {
    //     label: 'Data',
    //     route: 'data'
    // },    {
    //     label: 'Oneview',
    //     route: 'one-view'
    // }
];
